import React from 'react';

import { RecaptchaProvider } from '../../../src/shared/components/recaptcha-provider';
import { ApiProvider } from '../../../src/shared/providers/api.provider';
import { WidgetPageContent } from '../../../src/widget/components/widget-page-content';

function WidgetPage() {
  return (
    <ApiProvider apiType="widget">
      <RecaptchaProvider>
        <WidgetPageContent />
      </RecaptchaProvider>
    </ApiProvider>
  );
}

export default WidgetPage;
